import React from 'react';
import styled from 'astroturf/react';
import pluralize from 'pluralize';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { FollowableUser } from 'js/social/shared/types';
import { getSocialImpressionSource } from 'js/social/ImpressionHelper';
import { BigCardWrapper } from './BigCardWrapper';
import { BulkFollowPreview } from './BulkFollowPreview';
import { getFollowingSource } from './bulk_follow_modal_helper';

const MoreText = styled.a`
  color: $ds-primary-blue-active;
  font-weight: 500;
  cursor: pointer;
`;

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;

export type BigCardBulkFollowProps = {
  topic: {
    name: string;
    score: number;
  };
  topicScore: number;
  users: FollowableUser[];
  onMoreClick: () => void;
  onComplete: () => void;
};

export const BigCardBulkFollow: React.FC<BigCardBulkFollowProps> = ({
  topic,
  users,
  onMoreClick,
  onComplete = () => null,
}) => {
  const IMPRESSION_PAGE = 'home';
  const IMPRESSION_SECTION = 'feedhead';
  const header = (
    <>
      We found a set of academics related&nbsp;to
      <br />
      <span style={{ fontWeight: 500 }}>{topic.name}</span>
    </>
  );
  const description = (
    <>
      Featuring{' '}
      {users
        .slice(0, 3)
        .map((user) => user.displayName)
        .join(', ')}
      , plus{' '}
      <MoreText role="button" onClick={onMoreClick}>
        {pluralize('more academic', users.length - 3, true)}
      </MoreText>
    </>
  );

  return (
    <ImpressionWatcher
      source={getSocialImpressionSource(
        IMPRESSION_PAGE,
        IMPRESSION_SECTION,
        `bulk-follow-card`,
      )}
    >
      <Wrapper>
        <BigCardWrapper>
          <BulkFollowPreview
            topic={topic}
            header={header}
            description={description}
            users={users}
            followingSource={getFollowingSource('bulk_follow')}
            onComplete={onComplete}
          />
        </BigCardWrapper>
      </Wrapper>
    </ImpressionWatcher>
  );
};
